import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Button,
	Input,
	Form,
	Dropdown,
	Menu,
	Popconfirm,
	Tooltip,
	Skeleton,
	Space,
	Select,
	Upload,
	Radio,
	Tag,
	notification,
} from 'antd';
import {
	SendOutlined,
	PlusOutlined,
	HistoryOutlined,
	EditOutlined,
	DeleteOutlined,
	CheckOutlined,
	CloseOutlined,
	UploadOutlined,
	CheckCircleOutlined,
	InboxOutlined,
	ArrowUpOutlined,
	LinkOutlined,
	UpCircleTwoTone,
} from '@ant-design/icons';
import {
	XThemeVoiceaAssSearchBar,
	XThemeVoiceaAsistChatCard,
	// XThemeVSChatBar,
	XThemeHeaderBTN,
	XThemeVAAction,
	StyledWrapper,
	TypingLoaderWrapper,
	XThemeVSActionBtn,
	ThinkingText,
	XTextAreaShieldMaxx2,
	XTextAreaShieldMaxxBTN2,
	XAgentMaxTitle,
	XThemeReclaimSuggestionBTN,
} from '../VoiceAssistanceStyle';

import {
	sendMessageApi,
	sendMessageReset,
} from '../../../actions/sendMessageAction';
import {
	getConversationHistoryApi,
	getConversationHistoryReset,
} from '../../../actions/getConversationHistoryAction';
import {
	getUserConversationsApi,
	getUserConversationsReset,
} from '../../../actions/getUserConversationsAction';
import {
	deleteConversationApi,
	deleteConversationReset,
} from '../../../actions/deleteConversationAction';
import {
	updateConversationTitleApi,
	updateConversationTitleReset,
} from '../../../actions/updateConversationTitleAction';
import {
	storeMessageApi,
	storeMessageReset,
} from '../../../actions/storeMessageAction';
import { XAvatar } from '../../../components/Header/HeaderStyle';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../../actions/getStateDropdownAction';
import {
	getHospitalDropdownApi,
	getHospitalDropdownReset,
} from '../../../actions/getHospitalDropdownAction';
import { getInsuranceDropdownApi } from '../../../actions/getInsuranceDropdownAction';
import { getRegionsApi } from '../../../actions/getRegionsAction';
import { getOrganizationsApi } from '../../../actions/getOrganizationsAction';
import {
	sendMessageStreamApi,
	sendMessageStreamReset,
} from '../../../actions/sendMessageStreamAction';

import axios from 'axios';
import config from '../../../config';
import { getUserToken } from '../../../utils/helper';
import { XForm } from '../../../styles/GlobalThemeStyle';
import Dragger from 'antd/es/upload/Dragger';
import {
	XTheme2Button,
	XThemeContainer,
} from '../../../styles/GlobalThemeStyleCQ';
import {
	ParaShieldMaxx,
	XLottieShieldMaxx,
	XShieldMaxxTitle,
	XShieldSuggestionBTN,
	XTextAreaShieldMaxx,
	XTextAreaShieldMaxxBTN,
	XThemShieldDesktop,
} from '../../ShieldMaxx/ShieldMaxxStyle';
import ReclaimJson from '../../../json/Reclaim.json';
import AppealLoading from '../../../json/Reclaim.json';
import { XLottieLetter } from '../../AnalyseCoverage/AnalyseCoverageStyle';
import { useLocation, useNavigate } from 'react-router-dom';

const UnifiedChat = (props) => {
	// Move useLocation to the top, before any references to location
	const location = useLocation();
	const navigate = useNavigate(); // Add this to help with state clearing

	// Destructure props
	const {
		sendMessage,
		sendMessageApiState,
		sendMessageData,
		getConversationHistory,
		getConversationHistoryApiState,
		getConversationHistoryData,
		getUserConversations,
		getUserConversationsApiState,
		getUserConversationsData,
		deleteConversation,
		deleteConversationApiState,
		updateConversationTitle,
		updateConversationTitleApiState,
		resetSendMessage,
		resetGetConversationHistory,
		resetGetUserConversations,
		resetDeleteConversation,
		resetUpdateConversationTitle,
		storeMessage,
		storeMessageApiState,
		storeMessageData,
		resetStoreMessage,
		onActionReceived,
		isProcessingAction,
		greeting,
		userInfo,
		onConversationChange,
		initialConversationId,
		getStateDropdown,
		getStateDropdownState,
		getHospitalDropdown,
		getHospitalDropdownState,
		getInsuranceDropdown,
		getInsuranceDropdownState,
		getRegions,
		getRegionsState,
		getOrganizations,
		getOrganizationsState,
		sendMessageStream,
		sendMessageStreamApiState,
		sendMessageStreamData,
		sendMessageStreamState,
		sendMessageStreamAccumulatedText,
		sendMessageStreamThinkingText,
		sendMessageStreamConversationId,
		resetSendMessageStream,
		pendingUserInput: externalPendingUserInput,
		setPendingUserInput: setExternalPendingUserInput,
		setChatStarted,
		chatStarted,
		onMessagesChange, // Add this line
	} = props;
	const [chatInputForm] = Form.useForm();
	const [inputMessage, setInputMessage] = useState('');
	const [isListening, setIsListening] = useState(false);
	const [showGreeting, setShowGreeting] = useState(true);
	const [messages, setMessages] = useState([]);
	const [isTyping, setIsTyping] = useState(false);
	const [activeConversationId, setActiveConversationId] = useState(null);
	const [chatTitle, setChatTitle] = useState('Welcome to Maxxy');
	const [editingConversationId, setEditingConversationId] = useState(null);
	const [editedTitle, setEditedTitle] = useState('');
	const [userConversations, setUserConversations] = useState([]);
	const [pendingUserInput, setPendingUserInput] = useState(null);
	const [pendingAction, setPendingAction] = useState(null);
	const [inputOptions, setInputOptions] = useState([]);
	const [typingMessageId, setTypingMessageId] = useState(null);
	const [typingText, setTypingText] = useState('');
	const typingSpeed = 20; // milliseconds per character

	// Todo supporting doc uploader starts
	const [supportingDocFile, setSupportingDocFile] = useState(null);
	const [supportingDocFileList, setSupportingDocFileList] = useState([]);
	const [supportingDocName, setSupportingDocName] = useState('');
	const [supportingDocUploading, setSupportingDocUploading] = useState(false);

	// Around line 160, add this state:
	const [pendingBatchMessage, setPendingBatchMessage] = useState(null);

	const scrollWrapperRef = useRef(null);
	const recognitionRef = useRef(null);
	let typingTimer = null;

	// Initialize Speech Recognition
	useEffect(() => {
		if (
			'webkitSpeechRecognition' in window ||
			'SpeechRecognition' in window
		) {
			const SpeechRecognition =
				window.SpeechRecognition || window.webkitSpeechRecognition;
			const recognition = new SpeechRecognition();
			recognition.continuous = false;
			recognition.lang = 'en-US';
			recognition.interimResults = false;

			recognition.onstart = () => setIsListening(true);
			recognition.onend = () => setIsListening(false);
			recognition.onresult = (event) => {
				const transcript = event.results[0][0].transcript;
				handleSendMessage(transcript);
			};

			recognitionRef.current = recognition;
		}

		// Check for initialConversationId from URL
		if (initialConversationId) {
			setActiveConversationId(initialConversationId);
			setShowGreeting(false); // Immediately hide greeting
			setChatStarted(true);
			getConversationHistory({ conversation_id: initialConversationId });
		} else {
			// When no conversation ID (back button to main), reset to greeting
			setActiveConversationId(null);
			setShowGreeting(true);
			setChatStarted(false);
			setMessages([]);
			// Only fetch user conversations on load if we're not loading a specific conversation
			getUserConversations();
		}

		// Clean up on unmount
		return () => {
			resetSendMessage();
			resetGetConversationHistory();
			resetGetUserConversations();
			resetDeleteConversation();
			resetUpdateConversationTitle();
		};
	}, [initialConversationId]); // Add initialConversationId to dependency array

	// Scroll to the latest message
	useEffect(() => {
		if (scrollWrapperRef.current) {
			scrollWrapperRef.current.scrollTo({
				top: scrollWrapperRef.current.scrollHeight,
				behavior: 'smooth',
			});
		}
	}, [messages, isTyping]);

	// Handle API response for streaming message
	useEffect(() => {
		if (sendMessageStreamApiState === 'loading') {
			// Show typing indicator
			setIsTyping(true);

			// If we receive the conversation ID from the stream and we don't have an active one yet
			if (sendMessageStreamConversationId && !activeConversationId) {
				setActiveConversationId(sendMessageStreamConversationId);

				// Update URL with conversation ID
				if (onConversationChange) {
					onConversationChange(sendMessageStreamConversationId);
				}

				// Update the conversation list only once we have a conversation ID
				if (sendMessageStreamConversationId) {
					getUserConversations();
				}
			}

			// Handle different streaming states
			if (sendMessageStreamState === 'thinking') {
				// Check if thinking message already exists
				const existingThinkingMsg = messages.find(
					(msg) => msg.isThinking,
				);

				// Only create a new thinking message if it doesn't exist and we have text
				if (!existingThinkingMsg && sendMessageStreamThinkingText) {
					const thinkingMsg = {
						id: Date.now(),
						text: sendMessageStreamThinkingText,
						sender: 'system',
						isThinking: true,
					};
					setMessages((prevMessages) => [
						...prevMessages,
						thinkingMsg,
					]);
				}
				// Update existing thinking message if text changed
				else if (
					existingThinkingMsg &&
					sendMessageStreamThinkingText !== existingThinkingMsg.text
				) {
					setMessages(
						messages.map((msg) =>
							msg.isThinking
								? {
										...msg,
										text: sendMessageStreamThinkingText,
								  }
								: msg,
						),
					);
				}
			} else if (sendMessageStreamState === 'streaming') {
				// Find the message to update - either thinking message or last system message
				const msgToUpdate =
					messages.find((msg) => msg.isThinking) ||
					[...messages]
						.reverse()
						.find(
							(msg) =>
								msg.sender === 'system' && !msg.isProcessing,
						);

				if (msgToUpdate && sendMessageStreamAccumulatedText) {
					// Update existing message with formatted accumulated text
					setMessages(
						messages.map((msg) =>
							msg.id === msgToUpdate.id
								? {
										...msg,
										text: sendMessageStreamAccumulatedText,
										isThinking: false,
								  }
								: msg,
						),
					);
				}
				// If no system message found but we have accumulated text, create a new one
				else if (sendMessageStreamAccumulatedText && !msgToUpdate) {
					const newMsg = {
						id: Date.now(),
						text: sendMessageStreamAccumulatedText,
						sender: 'system',
					};
					setMessages((prevMessages) => [...prevMessages, newMsg]);
				}
			}
		} else if (
			sendMessageStreamApiState === 'success' &&
			sendMessageStreamData
		) {
			// Hide typing indicator
			setIsTyping(false);

			// Find the message to update - either thinking message or last system message
			const msgToUpdate =
				messages.find((msg) => msg.isThinking) ||
				[...messages]
					.reverse()
					.find(
						(msg) => msg.sender === 'system' && !msg.isProcessing,
					);

			let updatedMessages = messages;

			if (msgToUpdate) {
				// Update existing message with complete response and add backend IDs
				updatedMessages = messages.map((msg) =>
					msg.id === msgToUpdate.id
						? {
								...msg,
								text: sendMessageStreamData.response,
								isThinking: false,
								// Add backend fields
								action: sendMessageStreamData.action,
								parameters: sendMessageStreamData.parameters,
								component: sendMessageStreamData.component,
								user_input: sendMessageStreamData.user_input,
								user_input_provided:
									sendMessageStreamData.user_input_provided ||
									false,
								_id: sendMessageStreamData.assistant_message_id, // Use backend message ID
								is_processing_completed:
									sendMessageStreamData.is_processing_completed,
						  }
						: msg,
				);
			} else {
				// Create new message with complete response and backend IDs
				const newMsg = {
					id: Date.now(),
					text: sendMessageStreamData.response,
					sender: 'system',
					action: sendMessageStreamData.action,
					parameters: sendMessageStreamData.parameters,
					component: sendMessageStreamData.component,
					user_input: sendMessageStreamData.user_input,
					user_input_provided:
						sendMessageStreamData.user_input_provided || false,
					_id: sendMessageStreamData.assistant_message_id, // Use backend message ID
					is_processing_completed:
						sendMessageStreamData.is_processing_completed,
				};
				updatedMessages = [...messages, newMsg];
			}

			// // Also update the user message with the backend user_message_id if available
			// if (sendMessageStreamData.user_message_id) {
			// 	const lastUserMsgIndex = [...updatedMessages]
			// 		.reverse()
			// 		.findIndex((msg) => msg.sender === 'client');
			// 	if (lastUserMsgIndex !== -1) {
			// 		const actualIndex = updatedMessages.length - 1 - lastUserMsgIndex;
			// 		updatedMessages[actualIndex] = {
			// 			...updatedMessages[actualIndex],
			// 			_id: sendMessageStreamData.user_message_id,
			// 		};
			// 	}
			// }

			// Check response type and handle accordingly
			if (sendMessageStreamData.response_type === 'user_input_required') {
				// Store pending action for later execution
				setPendingAction({
					action: sendMessageStreamData.action,
					parameters: sendMessageStreamData.parameters,
					component: sendMessageStreamData.component,
				});

				// Store user input requirements
				setPendingUserInput(sendMessageStreamData.user_input);

				// Fetch data options
				fetchInputOptions(sendMessageStreamData.user_input);

				setMessages(updatedMessages);
			} else if (sendMessageStreamData.response_type === 'action') {
				// Notify parent component about the action
				onActionReceived(
					sendMessageStreamData.action,
					sendMessageStreamData.parameters,
					sendMessageStreamData.component,
				);

				// Add a processing message
				const processingMsg = {
					id: Date.now() + 2,
					text: 'Processing your request...',
					sender: 'system',
					isProcessing: true,
				};

				//Todo setMessages([...updatedMessages, processingMsg]);
				setMessages([...updatedMessages]);
			} else {
				// Regular text response
				setMessages(updatedMessages);
			}

			// Check if processing is not completed and call va-response-messages API
			if (
				sendMessageStreamData.is_processing_completed === false &&
				activeConversationId &&
				sendMessageStreamData.action === 'batch_details' &&
				sendMessageStreamData.parameters?.id
			) {
				console.log('Streaming API completed with is_processing_completed: false');
				console.log('Action:', sendMessageStreamData.action);
				console.log('Parameters:', sendMessageStreamData.parameters);
				console.log('Conversation ID:', activeConversationId);
				console.log('Triggering batch_details action to start va-response-messages polling');
				
				// Trigger the batch_details action which will be handled by VABatchController
				// VABatchController will automatically detect that processing is not completed
				// and start polling the va-response-messages API
				onActionReceived(
					'batch_details',
					sendMessageStreamData.parameters,
					sendMessageStreamData.component
				);
			}

			// Reset API state
			resetSendMessageStream();
		} else if (sendMessageStreamApiState === 'error') {
			// Handle error
			setIsTyping(false);

			// Update any thinking message
			const updatedMessages = messages.map((msg) =>
				msg.isThinking ? { ...msg, isThinking: false } : msg,
			);

			// Add error message
			const errorMessage = {
				id: Date.now(),
				text: "I'm sorry, I encountered an error processing your request. Please try again later.",
				sender: 'system',
			};

			setMessages([...updatedMessages, errorMessage]);

			// Reset API state
			resetSendMessageStream();
		}
	}, [
		sendMessageStreamApiState,
		sendMessageStreamData,
		sendMessageStreamState,
		sendMessageStreamAccumulatedText,
		sendMessageStreamThinkingText,
		sendMessageStreamConversationId,
		messages,
	]);

	// Handle API response for conversation history
	useEffect(() => {
		if (
			getConversationHistoryApiState === 'success' &&
			getConversationHistoryData
		) {
			const { messages: historyMessages, title } =
				getConversationHistoryData;

			// Update chat title if available
			if (title) {
				setChatTitle(title);
			}

			// Convert history messages to the format our UI uses and ensure proper chronological order
			const formattedMessages = historyMessages
				.map((msg) => ({
					id:
						typeof msg.created_at === 'number'
							? msg.created_at
							: new Date(msg.created_at).getTime(),
					text: msg.message,
					sender: msg.role === 'user' ? 'client' : 'system',
					action: msg.action,
					parameters: msg.parameters,
					component: msg.component,
					timestamp: msg.created_at,
					// Add new backend fields
					user_input: msg.user_input,
					user_input_provided: msg.user_input_provided || false,
					user_input_message_id: msg.user_input_message_id,
					_id: msg._id, // Store the MongoDB _id for backend reference
					is_processing_completed: msg.is_processing_completed, // Include the processing completion flag
				}))
				.reverse();
			// Remove this sort to preserve API order
			// .sort((a, b) => {
			//     // Handle different timestamp formats
			//     const timeA =
			//         typeof a.timestamp === 'number'
			//             ? a.timestamp
			//             : new Date(a.timestamp).getTime();
			//     const timeB =
			//         typeof b.timestamp === 'number'
			//             ? b.timestamp
			//             : new Date(b.timestamp).getTime();
			//     return timeA - timeB;
			// });

			setMessages(formattedMessages);
			setShowGreeting(false);
			setChatStarted(true);

			// Add a small delay before triggering any action
			setTimeout(() => {
				// Check if there's an action in the conversation to display in the left section
				const lastActionMessage = [...formattedMessages]
					.reverse()
					.find(
						(msg) =>
							msg.action && msg.action !== 'reset_to_default',
					);
				console.log('Last action message found:', lastActionMessage);
				if (lastActionMessage && lastActionMessage.action) {
					onActionReceived(
						lastActionMessage.action,
						lastActionMessage.parameters,
						lastActionMessage.component,
					);
				}
			}, 100);

			// Reset API state
			resetGetConversationHistory();

			// After loading conversation, fetch the user's conversations
			// This ensures we load them only once
			getUserConversations();
		} else if (getConversationHistoryApiState === 'error') {
			// Handle invalid conversation ID - redirect to new chat
			console.log('Conversation not found, redirecting to new chat');
			if (onConversationChange) {
				onConversationChange(null);
			}
			resetGetConversationHistory();
		}
	}, [getConversationHistoryApiState, getConversationHistoryData]);

	// Handle API response for user conversations
	useEffect(() => {
		if (
			getUserConversationsApiState === 'success' &&
			getUserConversationsData
		) {
			setUserConversations(getUserConversationsData.conversations || []);

			// Find and set the current chat title if we have an active conversation
			if (activeConversationId) {
				const currentChat = (
					getUserConversationsData.conversations || []
				).find((conv) => conv._id === activeConversationId);

				if (currentChat) {
					setChatTitle(currentChat.title);
				} else if (initialConversationId) {
					// If conversation not found but was requested in URL, redirect to new chat
					console.log(
						'Conversation ID not found in user conversations, redirecting to new chat',
					);
					clearMessages();
					if (onConversationChange) {
						onConversationChange(null);
					}
				}
			}

			resetGetUserConversations();
		}
	}, [getUserConversationsApiState, getUserConversationsData]);

	// Handle API response for delete conversation
	useEffect(() => {
		if (deleteConversationApiState === 'success') {
			// If the deleted conversation was the active one, reset to greeting screen
			if (
				activeConversationId &&
				!userConversations.some((c) => c._id === activeConversationId)
			) {
				clearMessages();
			}

			// Refresh conversation list
			getUserConversations();

			resetDeleteConversation();
		}
	}, [deleteConversationApiState]);

	// Handle API response for updating conversation title
	useEffect(() => {
		if (updateConversationTitleApiState === 'success') {
			// Refresh conversation list
			getUserConversations();

			// Reset editing state
			setEditingConversationId(null);

			resetUpdateConversationTitle();
		}
	}, [updateConversationTitleApiState]);

	// Note: va-response-messages API response is handled by VABatchController.js

	// Handle Sending Message (Text or Voice)
	const handleSendMessage = (message = inputMessage) => {
		if (message.trim() === '') return;

		// Hide greeting when user sends first message
		if (showGreeting) {
			setShowGreeting(false);
			setChatStarted(true);
		}

		// Add user message to UI immediately
		const newMessage = {
			id: Date.now(),
			text: message,
			sender: 'client',
		};

		setMessages((prevMessages) => [...prevMessages, newMessage]);
		setInputMessage('');

		// Show typing indicator
		setIsTyping(true);

		// Prepare API data
		const apiData = {
			message: message,
		};

		// If we have an active conversation, include its ID
		if (activeConversationId) {
			apiData.conversation_id = activeConversationId;
		}

		// Call streaming API to send message
		sendMessageStream(apiData);
		chatInputForm.setFieldsValue({
			chatMessage: '',
		});
	};

	// Start Voice Recognition
	const startVoiceRecognition = () => {
		if (recognitionRef.current) {
			recognitionRef.current.start();
		}
	};

	// Create a new chat
	const startNewChat = () => {
		clearMessages();

		// First, clear any action in the left section
		onActionReceived(null, null);

		// Force a new API call by using the parent's VoiceAssistance component
		if (onConversationChange) {
			// First update the URL (removes conversationId)
			onConversationChange(null);

			// Then explicitly tell VSChard176 to make the default API call
			// by triggering a special action type
			setTimeout(() => {
				onActionReceived('reset_to_default', null);
			}, 50);
		}
	};

	// Clear chat messages
	const clearMessages = () => {
		setMessages([]);
		setShowGreeting(true);
		setChatStarted(false);
		setActiveConversationId(null);
		setPendingUserInput(null);
		setChatTitle('Welcome to Maxxy');
		chatInputForm.setFieldsValue({
			chatMessage: '',
		});
		// Update URL to remove conversation ID
		if (onConversationChange) {
			onConversationChange(null);
		}
	};

	// Load a conversation from history
	const loadConversation = (conversationId) => {
		if (conversationId === activeConversationId) return;

		// Don't clear action here - this is causing default API call
		// onActionReceived(null, null);

		setActiveConversationId(conversationId);

		// Update URL with conversation ID first
		if (onConversationChange) {
			onConversationChange(conversationId);
		}

		// Then load the conversation history
		// The history's success handler will properly set the action
		getConversationHistory({ conversation_id: conversationId });
	};

	// Handle title editing
	const startTitleEdit = (e, conversationId, title) => {
		e.stopPropagation();
		setEditingConversationId(conversationId);
		setEditedTitle(title);
	};

	const saveTitleEdit = (e, conversationId) => {
		e.stopPropagation();

		if (editedTitle.trim() !== '') {
			updateConversationTitle({
				conversation_id: conversationId,
				title: editedTitle,
			});

			if (conversationId === activeConversationId) {
				setChatTitle(editedTitle);
			}
		}
	};

	const cancelTitleEdit = (e) => {
		e.stopPropagation();
		setEditingConversationId(null);
	};

	// Handle conversation deletion
	const handleDeleteConversation = (conversationId) => {
		deleteConversation({ conversation_id: conversationId });

		// Always clear messages if we're deleting a conversation (regardless of whether it's active)
		if (conversationId === activeConversationId) {
			clearMessages();
			// Clear any action in the left section
			onActionReceived(null, null);
		}
	};

	// Scroll to top of chat
	const handleScrollToTop = () => {
		if (scrollWrapperRef.current) {
			scrollWrapperRef.current.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	};

	// Handle typing animation
	const handleInputTyping = (e) => {
		setInputMessage(e.target.value);

		if (typingTimer) clearTimeout(typingTimer);
		typingTimer = setTimeout(() => {
			// Clear typing status after timeout
		}, 1000);
	};

	// Handle clicking on suggested actions
	const handleSuggestionClick = (suggestion) => {
		chatInputForm.setFieldsValue({
			chatMessage: suggestion,
		});
		setInputMessage(suggestion);
		// handleSendMessage(suggestion);
	};

	// Generate conversation history menu items
	const getConversationItems = () => {
		if (userConversations.length === 0) {
			return [
				<Menu.Item key="no-convo" disabled>
					No conversations found
				</Menu.Item>,
			];
		}

		return userConversations.map((conv) => (
			<Menu.Item
				key={conv._id}
				onClick={() => loadConversation(conv._id)}
				style={{
					backgroundColor:
						activeConversationId === conv._id
							? '#f0f0f0'
							: 'transparent',
					borderLeft:
						activeConversationId === conv._id
							? '3px solid #1890ff'
							: 'none',
					padding: '8px 12px',
					marginBottom: '4px',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div
						style={{
							flex: '1',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							maxWidth: '180px',
						}}
					>
						{editingConversationId === conv._id ? (
							<Input
								size="small"
								value={editedTitle}
								onChange={(e) => setEditedTitle(e.target.value)}
								onClick={(e) => e.stopPropagation()}
								onPressEnter={(e) => saveTitleEdit(e, conv._id)}
								autoFocus
								style={{ width: '120px' }}
							/>
						) : (
							<span>{conv.title || 'Untitled Conversation'}</span>
						)}
					</div>
					<div style={{ display: 'flex', marginLeft: '8px' }}>
						{editingConversationId === conv._id ? (
							<>
								<Button
									size="small"
									type="text"
									icon={<CheckOutlined />}
									onClick={(e) => saveTitleEdit(e, conv._id)}
									style={{ marginRight: '4px' }}
								/>
								<Button
									size="small"
									type="text"
									icon={<CloseOutlined />}
									onClick={cancelTitleEdit}
								/>
							</>
						) : (
							<>
								<Button
									size="small"
									type="text"
									icon={<EditOutlined />}
									onClick={(e) =>
										startTitleEdit(e, conv._id, conv.title)
									}
									style={{ marginRight: '4px' }}
								/>
								<Popconfirm
									title="Delete this conversation?"
									onConfirm={(e) => {
										e.stopPropagation();
										handleDeleteConversation(conv._id);
									}}
									okText="Delete"
									cancelText="Cancel"
									placement="left"
								>
									<Button
										size="small"
										type="text"
										icon={<DeleteOutlined />}
										onClick={(e) => e.stopPropagation()}
									/>
								</Popconfirm>
							</>
						)}
					</div>
				</div>
			</Menu.Item>
		));
	};

	// Add this function near the other handler functions (around line 800):
	const handleHistoryDropdownVisibleChange = (visible) => {
		if (visible) {
			// Refresh conversations when dropdown opens
			getUserConversations();
		}
	};

	// History menu
	const historyMenu = (
		<Menu style={{ width: '310px', maxHeight: '400px', overflowY: 'auto' }}>
			{getConversationItems()}
		</Menu>
	);

	// Header buttons for history and new chat
	const historyButtons = (
		<Row className="align-items-center">
			<Col xs={12}>
				<XAgentMaxTitle>
					<span>{chatTitle}</span>
				</XAgentMaxTitle>
			</Col>
			<Col xs={12} className="text-end">
				<Dropdown
					overlay={historyMenu}
					trigger={['click']}
					placement="bottomRight"
					size="large"
					onVisibleChange={handleHistoryDropdownVisibleChange}
				>
					<XTheme2Button
						className="chatStyle noBackground me-2"
						size="large"
						icon={<HistoryOutlined />}
					/>
				</Dropdown>
				{!showGreeting && (
					<Tooltip title="New Chat">
						<XTheme2Button
							className="chatStyle noBackground"
							onClick={startNewChat}
							size="large"
							icon={<PlusOutlined />}
							defaultBorderColor="#E9E9EA"
						/>
					</Tooltip>
				)}
			</Col>
		</Row>
	);

	// Modified handleUserInputSubmit to store user input selection in DB
	const handleUserInputSubmit = (value, option, messageId = null) => {
		// Find the message that contains the user input
		let targetMessage = null;

		if (messageId) {
			targetMessage = messages.find((msg) => msg.id === messageId);
		} else {
			// Fallback: find the message with pending user input
			targetMessage = messages.find(
				(msg) => msg.user_input && !msg.user_input_provided,
			);
		}

		if (!targetMessage) {
			console.error('No message with user input found');
			return;
		}

		const userInput = targetMessage.user_input;

		// Get action details from the message
		const messageAction = targetMessage.action;
		const messageParameters = targetMessage.parameters;
		const messageComponent = targetMessage.component;
		const isProcessingCompleted = targetMessage.is_processing_completed;

		if (messageAction && userInput && activeConversationId) {
			const updatedParameters = {
				...messageParameters,
				is_processing_completed: isProcessingCompleted,
				messages: messages[1]?.text || '',
			};

			// Special handling for confirm_coverage
			if (userInput.parameter_key === 'confirm_coverage') {
				// Get a user-friendly display value
				const userResponse =
					value === 'Yes'
						? 'Yes, confirm coverage'
						: "No, don't confirm coverage";

				//todo // First store the assistant's question as a system message
				// storeMessage({
				// 	response_type: 'text',
				// 	message: pendingUserInput.title,
				// 	action: 'case-details',
				// 	component: pendingAction.component,
				// 	parameters: updatedParameters,
				// 	conversation_id: activeConversationId,
				// 	user_input: pendingUserInput.title,
				// 	role: 'assistant',
				// });
				// Use the real MongoDB ID if available, otherwise backend will handle it by position
				const messageIdToUse =
					targetMessage._id && !targetMessage._id.startsWith('temp_')
						? targetMessage._id
						: null;

				// Then store the user's response as a user message
				storeMessage({
					response_type: 'text',
					message: userResponse,
					action: messageAction,
					component: messageComponent,
					parameters: updatedParameters,
					user_input: userResponse,
					conversation_id: activeConversationId,
					role: 'user',
					message_id: messageIdToUse, // Use real MongoDB _id or null for fallback
				});

				// Update local messages - mark as provided and add user response
				const messageIndex = messages.findIndex(
					(msg) => msg.id === targetMessage.id,
				);
				const userMsg = {
					id: Date.now(),
					text: userResponse,
					sender: 'client',
				};

				const updatedMessages = [
					...messages.slice(0, messageIndex),
					{
						...targetMessage,
						user_input_provided: true,
					},
					userMsg,
					...messages.slice(messageIndex + 1),
				];

				setMessages(updatedMessages);

				if (value === 'Yes') {
					//Thinking message saying confirming coverage
					const thinkingMsg = {
						id: Date.now() + 1,
						text: 'Confirming coverage...',
						sender: 'system',
						isThinking: true,
					};
					setMessages([...updatedMessages, thinkingMsg]);
					// Execute the action with updated parameters
					onActionReceived(
						messageAction,
						updatedParameters,
						messageComponent,
					);
				}

				// Clear global pending states
				setPendingUserInput(null);
				setPendingAction(null);
				return;
			}

			// Handle other input types (state selection, etc.)
			if (
				userInput.parameter_key === 'state' &&
				userInput.original_parameter_key === 'insurance_company'
			) {
				updatedParameters['state'] = value;

				const displayValue = option?.name || option?.label || value;
				const userResponse = `${displayValue}`;

				// todo // First store the assistant's question
				// storeMessage({
				// 	conversation_id: activeConversationId,
				// 	user_input: userInput.title,
				// 	role: 'assistant',
				// });
				// Store the user's selection
				const messageIdToUse =
					targetMessage._id && !targetMessage._id.startsWith('temp_')
						? targetMessage._id
						: null;

				// Then store the user's selection
				storeMessage({
					conversation_id: activeConversationId,
					user_input: userResponse,
					role: 'user',
					message_id: messageIdToUse,
				});

				// Update local messages
				const messageIndex = messages.findIndex(
					(msg) => msg.id === targetMessage.id,
				);
				const userMsg = {
					id: Date.now(),
					text: userResponse,
					sender: 'client',
				};

				const confirmationMsg = {
					id: Date.now() + 1,
					text: `Selected state: ${displayValue}`,
					sender: 'system',
					// Add next user input
					user_input: {
						...userInput,
						parameter_key: 'insurance_company',
						title: 'Select an Insurance Company',
						original_parameter_key: null,
					},
					user_input_provided: false,
					action: messageAction,
					parameters: updatedParameters,
					component: messageComponent,
					_id: `temp_${Date.now()}`, // Temporary ID for new messages created locally
				};

				const updatedMessages = [
					...messages.slice(0, messageIndex),
					{
						...targetMessage,
						user_input_provided: true,
					},
					userMsg,
					confirmationMsg,
					...messages.slice(messageIndex + 1),
				];

				setMessages(updatedMessages);

				getStateDropdown();
				return;
			}

			// Handle all other input types
			if (userInput.parameter_key) {
				updatedParameters[userInput.parameter_key] = value;
			}

			const displayValue = option?.name || option?.label || value;
			const userResponse = `${displayValue}`;

			// todo // First store the assistant's question
			// storeMessage({
			// 	conversation_id: activeConversationId,
			// 	user_input: userInput.title,
			// 	role: 'assistant',
			// });

			// Store the user's selection
			const messageIdToUse =
				targetMessage._id && !targetMessage._id.startsWith('temp_')
					? targetMessage._id
					: null;

			if (
				messageAction === 'create_batch' &&
				updatedParameters.create_batch === 'Yes'
			) {
				// Store these details in state for later use
				setPendingBatchMessage({
					conversation_id: activeConversationId,
					user_input: userResponse,
					action: 'batch_details', // Change to batch_details for storage
					role: 'user',
					response_type: 'text',
					message: userResponse,
					component: messageComponent,
					parameters: updatedParameters,
					message_id: messageIdToUse,
				});

				console.log(
					'Batch creation - storing message details for later',
				);
				// DON'T store the message immediately for batch creation
				// Let the VABatchController handle it after successful creation
				console.log(
					'Batch creation - skipping immediate message storage',
				);
			} else {
				// Store message for other actions
				storeMessage({
					response_type: 'text',
					conversation_id: activeConversationId,
					user_input: userResponse,
					action: messageAction,
					parameters: updatedParameters,
					role: 'user',
					component: messageComponent,
					message_id: messageIdToUse,
				});
			}

			// Update local messages
			const messageIndex = messages.findIndex(
				(msg) => msg.id === targetMessage.id,
			);
			const userMsg = {
				id: Date.now(),
				text: userResponse,
				isConfirmation: true,
				sender: 'client',
			};

			const updatedMessages = [
				...messages.slice(0, messageIndex),
				{
					...targetMessage,
					user_input_provided: true,
				},
				userMsg,
				...messages.slice(messageIndex + 1),
			];

			// if (
			// 	messageAction === 'create_batch' &&
			// 	updatedParameters.create_batch === 'Yes'
			// ) {
			// 	console.log(
			// 		'Batch creation - skipping immediate message storage',
			// 	);
			// } else {
			setMessages(updatedMessages);
			// }

			// Execute the action with updated parameters
			onActionReceived(
				messageAction,
				updatedParameters,
				messageComponent,
			);

			// Clear global pending states
			setPendingUserInput(null);
			setPendingAction(null);
			setInputOptions([]);
		}
	};

	// Updated renderUserInputUI to show appropriate messages for the state->insurance flow
	const renderUserInputUI = (userInput, messageId) => {
		if (!userInput) return null;

		const {
			input_type,
			parameter_key,
			title,
			search_value,
			original_parameter_key,
		} = userInput;

		switch (input_type) {
			case 'chips':
				return (
					<div
						className="userInputContainer"
						style={{
							padding: '15px',
							background: '#f8f9fa',
							borderRadius: '10px',
						}}
					>
						<div
							className="inputTitle"
							style={{
								fontSize: '16px',
								fontWeight: '500',
								marginBottom: '12px',
								color: '#212226',
							}}
						>
							{title}
						</div>

						{/* Special messaging for state selection before insurance company */}
						{original_parameter_key === 'insurance_company' &&
							parameter_key === 'state' && (
								<div
									className="searchInfo"
									style={{
										marginBottom: '12px',
										fontSize: '14px',
										color: '#666',
									}}
								>
									Insurance companies are specific to states.
									Please select a state first to see available
									insurance companies.
								</div>
							)}

						{/* Standard messaging for other scenarios */}
						{!original_parameter_key && search_value && (
							<div
								className="searchInfo"
								style={{
									marginBottom: '12px',
									fontSize: '14px',
									color: '#666',
								}}
							>
								You searched for "{search_value}". Please select
								one option:
							</div>
						)}

						{/* Loading state */}
						{((parameter_key === 'hospital' &&
							getHospitalDropdownState.apiState === 'loading') ||
							(parameter_key === 'state' &&
								getStateDropdownState.apiState === 'loading') ||
							(parameter_key === 'region' &&
								getRegionsState.apiState === 'loading') ||
							(parameter_key === 'organization' &&
								getOrganizationsState.apiState ===
									'loading')) && (
							<div
								className="loadingChips"
								style={{
									padding: '10px',
									textAlign: 'center',
									color: '#666',
								}}
							>
								Loading options...
							</div>
						)}

						{/* No results found */}
						{inputOptions.length === 0 &&
							!['loading'].includes(
								parameter_key === 'hospital'
									? getHospitalDropdownState.apiState
									: parameter_key === 'state'
									? getStateDropdownState.apiState
									: parameter_key === 'region'
									? getRegionsState.apiState
									: parameter_key === 'organization'
									? getOrganizationsState.apiState
									: '',
							) && (
								<div
									className="noResults"
									style={{
										padding: '10px',
										textAlign: 'center',
										color: '#666',
									}}
								>
									No {parameter_key.replace('_', ' ')} options
									available.
								</div>
							)}

						{/* Chips display */}
						{inputOptions.length > 0 && (
							<div
								className="chipsWrapper"
								style={{
									display: 'flex',
									flexWrap: 'wrap',
									gap: '10px',
									marginTop: '10px',
								}}
							>
								{inputOptions.map((option, index) => (
									<XThemeVSActionBtn
										key={index}
										onClick={() =>
											handleUserInputSubmit(
												option.value,
												option,
												messageId, // Pass messageId
											)
										}
										className="chip-item"
										style={{
											margin: '0',
											padding: '8px 16px',
											borderRadius: '20px',
											fontSize: '14px',
											whiteSpace: 'nowrap',
											maxWidth: '100%',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										}}
									>
										{option.name || option.label}
									</XThemeVSActionBtn>
								))}
							</div>
						)}
					</div>
				);

			case 'file_upload':
				// For file upload
				return (
					<div className="userInputContainer">
						<div className="inputTitle">{title}</div>
						<Upload
							beforeUpload={(file) => {
								handleUserInputSubmit(file, null, messageId);
								return false;
							}}
							maxCount={1}
						>
							<Button icon={<UploadOutlined />}>
								Select File
							</Button>
						</Upload>
					</div>
				);

			case 'buttons':
				// For yes/no or multiple choice buttons
				return (
					<div className="userInputContainer">
						<Space>
							{userInput.options &&
								userInput.options.map((option, index) => (
									<XThemeVSActionBtn
										key={index}
										onClick={() =>
											handleUserInputSubmit(
												option.value,
												option,
												messageId, // Pass messageId
											)
										}
									>
										{option.label}
									</XThemeVSActionBtn>
								))}
						</Space>
					</div>
				);

			case 'radio':
				// For radio selection
				return (
					<div className="userInputContainer">
						<div className="inputTitle">{title}</div>
						<Radio.Group
							onChange={(e) =>
								handleUserInputSubmit(
									e.target.value,
									null,
									messageId,
								)
							}
						>
							{userInput.options &&
								userInput.options.map((option, index) => (
									<Radio key={index} value={option.value}>
										{option.label}
									</Radio>
								))}
						</Radio.Group>
					</div>
				);

			case 'supporting_document_uploader':
				return (
					<div
						className="userInputContainer"
						style={{
							padding: '15px',
							background: '#f8f9fa',
							borderRadius: '10px',
						}}
					>
						<div
							className="inputTitle"
							style={{
								fontSize: '16px',
								fontWeight: '500',
								marginBottom: '12px',
								color: '#212226',
							}}
						>
							{title || 'Upload Supporting Document'}
						</div>
						<XForm layout="vertical" autoComplete="off">
							<XForm.Item
								name="supporting_doc_file"
								rules={[
									{
										required: true,
										validator: (_, value) => {
											if (!supportingDocFile) {
												return Promise.reject(
													new Error(
														'Please select a file!',
													),
												);
											}
											return Promise.resolve();
										},
									},
								]}
							>
								<Dragger
									fileList={supportingDocFileList}
									maxCount={1}
									beforeUpload={(file) => {
										const isJPEG =
											file.type === 'image/jpeg';
										const isJPG = file.type === 'image/jpg';
										const isPNG = file.type === 'image/png';
										const isGIF = file.type === 'image/gif';
										const isVideo =
											file.type.startsWith('video/');
										const isAudio =
											file.type.startsWith('audio/');

										const isLt10M =
											file.size / 1024 / 1024 < 10;

										if (!isLt10M) {
											notification.error({
												message: 'File Size Exceeded',
												description: `The file ${file.name} exceeds the maximum allowed size of 10MB.`,
											});
										}
										if (
											isGIF ||
											isVideo ||
											isAudio ||
											isJPEG ||
											isJPG ||
											isPNG
										) {
											notification.error({
												message: 'File Type Error',
												description: `GIF, video, image and audio files are not allowed.`,
											});
										}

										return (
											isLt10M &&
											!isGIF &&
											!isVideo &&
											!isAudio &&
											!isJPEG &&
											!isJPG &&
											!isPNG
										);
									}}
									accept=".pdf"
									onChange={handleSupportingDocChange}
								>
									<p className="ant-upload-drag-icon">
										<InboxOutlined
											style={{ color: '#007299' }}
										/>
									</p>
									<p className="ant-upload-text">
										Click or drag file to this area to
										upload
									</p>
								</Dragger>
							</XForm.Item>
							<XForm.Item
								name="document_name"
								label="Document Name"
								className="mt-3"
								rules={[
									{
										required: true,
										message: 'Document Name is required',
									},
								]}
							>
								<Select
									className="largeInputForms"
									size="large"
									placeholder="Select Document Name"
									name="document_name"
									onChange={(value) =>
										setSupportingDocName(value)
									}
									options={[
										{
											value: 'Consult Note',
											label: 'Consult Note',
										},
										{
											value: 'Treatment Plan',
											label: 'Treatment Plan',
										},
										{
											value: 'Denial Letter',
											label: 'Denial Letter',
										},
										{ value: 'Other', label: 'Other' },
									]}
								/>
							</XForm.Item>
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									marginTop: '15px',
								}}
							>
								<Button
									type="primary"
									onClick={() =>
										handleSupportingDocSubmit(messageId)
									}
									loading={supportingDocUploading}
									disabled={
										!supportingDocFile || !supportingDocName
									}
									style={{
										backgroundColor: '#007299',
										borderColor: '#007299',
									}}
								>
									Upload Document
								</Button>
							</div>
						</XForm>
					</div>
				);

			default:
				return null;
		}
	};

	// Todo external functions starts
	// Modified fetchInputOptions function to handle insurance companies specially

	const fetchInputOptions = (userInput) => {
		if (!userInput) return;

		const { parameter_key, search_value } = userInput;

		// Special handling for insurance company
		if (parameter_key === 'insurance_company') {
			// If we don't have a state yet, we need to get states first
			if (!pendingAction?.parameters?.state) {
				// Update pendingUserInput to ask for state first
				setPendingUserInput({
					...userInput,
					parameter_key: 'state',
					title: 'Select a State first',
					original_parameter_key: 'insurance_company', // Store original parameter key
				});

				// Get all states
				getStateDropdown();
				return;
			} else {
				// We already have state, now get insurance companies for this state
				getStateDropdown(); // This will give us providers for the selected state
			}
		}
		// Standard handling for other entity types
		else if (parameter_key === 'hospital') {
			getHospitalDropdown();
		} else if (parameter_key === 'state') {
			getStateDropdown();
		} else if (parameter_key === 'region') {
			getRegions();
		} else if (parameter_key === 'organization') {
			getOrganizations();
		}
	};

	// Watch for dropdown data responses
	useEffect(() => {
		if (
			getHospitalDropdownState.apiState === 'success' &&
			pendingUserInput?.parameter_key === 'hospital'
		) {
			const hospitals = getHospitalDropdownState.data.hospitals || [];
			setInputOptions(
				hospitals.map((hospital) => ({
					label: hospital.name,
					value: hospital._id,
					name: hospital.name,
				})),
			);
		}
	}, [getHospitalDropdownState]);

	useEffect(() => {
		if (
			getStateDropdownState.apiState === 'success' &&
			pendingUserInput?.parameter_key === 'state'
		) {
			const states = getStateDropdownState.data.all_states || [];
			setInputOptions(
				states.map((state) => ({
					label: state.state,
					value: state.state,
					name: state.state,
				})),
			);
		}
	}, [getStateDropdownState]);

	useEffect(() => {
		if (
			getRegionsState.apiState === 'success' &&
			pendingUserInput?.parameter_key === 'region'
		) {
			const regions = getRegionsState.data.regions || [];
			setInputOptions(
				regions.map((region) => ({
					label: region.name,
					value: region._id,
					name: region.name,
				})),
			);
		}
	}, [getRegionsState]);

	useEffect(() => {
		if (
			getOrganizationsState.apiState === 'success' &&
			pendingUserInput?.parameter_key === 'organization'
		) {
			const organizations = getOrganizationsState.data.list || [];
			setInputOptions(
				organizations.map((org) => ({
					label: org.name,
					value: org._id,
					name: org.name,
				})),
			);
		}
	}, [getOrganizationsState]);

	// Update state dropdown handler to show insurance companies if needed
	useEffect(() => {
		if (getStateDropdownState.apiState === 'success') {
			if (pendingUserInput?.parameter_key === 'state') {
				const states = getStateDropdownState.data.all_states || [];

				setInputOptions(
					states.map((state) => ({
						label: state.state,
						value: state.state,
						name: state.state,
						providers: state.providers, // Store providers for later use
					})),
				);
			}
			// If we have state parameter and original key was insurance_company, extract providers
			else if (
				pendingUserInput?.parameter_key === 'insurance_company' &&
				pendingAction?.parameters?.state
			) {
				// Find the state in the data
				const states = getStateDropdownState.data.all_states || [];
				const selectedState = states.find(
					(state) => state.state === pendingAction.parameters.state,
				);

				if (selectedState && selectedState.providers) {
					// Set insurance companies as options
					setInputOptions(
						selectedState.providers.map((provider) => ({
							label: provider.name,
							value: provider._id,
							name: provider.name,
						})),
					);
				} else {
					// No providers found for this state
					setInputOptions([]);
				}
			}
		}
	}, [getStateDropdownState, pendingUserInput, pendingAction]);

	// Add useEffect to handle external user input requests
	useEffect(() => {
		if (externalPendingUserInput) {
			// Add a small delay before processing new messages to ensure proper sequencing
			setTimeout(() => {
				// Handle batch creation completion - ADD THIS BLOCK
				if (
					externalPendingUserInput.response_type ===
						'batch_created' &&
					pendingBatchMessage
				) {
					// Now store the message with the real batch ID
					storeMessage({
						...pendingBatchMessage,
						parameters: {
							id: externalPendingUserInput.batch_id,
						},
					});

					// Clear the pending message
					setPendingBatchMessage(null);

					// Clear the external state
					if (setExternalPendingUserInput) {
						setExternalPendingUserInput(null);
					}
					return;
				}

				// Handle batch creation failure - ADD THIS BLOCK TOO
				if (
					externalPendingUserInput.response_type ===
						'batch_creation_failed' &&
					pendingBatchMessage
				) {
					// Clear pending message on failure
					setPendingBatchMessage(null);

					if (setExternalPendingUserInput) {
						setExternalPendingUserInput(null);
					}
					return;
				}

				// NEW: Handle clear_thinking_only flag - bypass all message creation
				if (externalPendingUserInput.clear_thinking_only) {
					// Only remove thinking messages, don't add any new message
					setMessages((prevMessages) => {
						return prevMessages.filter((msg) => !msg.isThinking);
					});
					
					// Clear the external state
					if (setExternalPendingUserInput) {
						setExternalPendingUserInput(null);
					}
					return;
				}

				// Store pending action for later execution
				setPendingAction({
					action: externalPendingUserInput.action,
					parameters: externalPendingUserInput.parameters,
					component: externalPendingUserInput.component,
				});

				//todo if (externalPendingUserInput?.user_input) {
				// 	// Store user input requirements
				// 	setPendingUserInput(externalPendingUserInput?.user_input);
				// 	// Fetch data options
				// 	fetchInputOptions(externalPendingUserInput?.user_input);
				// }

				if (externalPendingUserInput.response_type === 'thinking') {
					// For thinking messages, replace any existing thinking message or add new one
					setMessages((prevMessages) => {
						// Remove any existing thinking message
						const messagesWithoutThinking = prevMessages.filter(
							(msg) => !msg.isThinking,
						);

						// Add the new thinking message
						return [
							...messagesWithoutThinking,
							{
								id: Date.now(),
								text: externalPendingUserInput.response,
								sender: 'system',
								isThinking: true,
							},
						];
					});
				} else {
					// For non-thinking messages, remove any thinking message and add the new message
					setMessages((prevMessages) => {
						// Remove any existing thinking message
						const messagesWithoutThinking = prevMessages.filter(
							(msg) => !msg.isThinking,
						);

						// Add the new regular message with user_input if present
						const newMessage = {
							id: Date.now(),
							text: externalPendingUserInput.response,
							sender: 'system',
							// Add user input fields if present
							user_input:
								externalPendingUserInput.user_input || null,
							user_input_provided: false,
							action: externalPendingUserInput.action,
							parameters: externalPendingUserInput.parameters,
							component: externalPendingUserInput.component,
							_id:
								externalPendingUserInput.message_id ||
								`temp_${Date.now()}`, // Temporary ID that will be replaced with real MongoDB ID
							is_processing_completed: externalPendingUserInput.is_processing_completed, // Add the flag to local message
						};

						// Only store non-thinking messages if store_message flag is true
						if (externalPendingUserInput.store_message) {
							storeMessage({
								conversation_id: activeConversationId,
								user_input: externalPendingUserInput.user_input,
								response_type:
									externalPendingUserInput.response_type,
								role: 'assistant',
								action: externalPendingUserInput.action,
								component: externalPendingUserInput.component,
								parameters: externalPendingUserInput.parameters,
								message: externalPendingUserInput.response,
								is_processing_completed: externalPendingUserInput.is_processing_completed, // Pass through the flag
							});
						}

						return [...messagesWithoutThinking, newMessage];
					});

					// Fetch input options if user input is required
					if (externalPendingUserInput?.user_input) {
						fetchInputOptions(externalPendingUserInput?.user_input);
					}
				}

				// Clear the external state
				if (setExternalPendingUserInput) {
					setExternalPendingUserInput(null);
				}
			}, 200); // Small delay to ensure proper message sequencing
			// // Execute the action with updated parameters
			// onActionReceived(
			// 	externalPendingUserInput.action,
			// 	externalPendingUserInput.parameters,
			// 	externalPendingUserInput.component,
			// );
		}
	}, [externalPendingUserInput]);

	// Todo supporting doc uploader starts
	// Add these handler functions
	const handleSupportingDocChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error' || file.status === 'uploading') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setSupportingDocFileList(updatedFileList);
		setSupportingDocFile(newFileList[0]?.originFileObj || null);
	};

	const handleSupportingDocSubmit = async (messageId) => {
		if (
			!supportingDocFile ||
			!supportingDocName ||
			!pendingAction?.parameters?.id
		) {
			notification.error({
				message: 'Missing Information',
				description:
					'Please select a file and provide a document name.',
			});
			return;
		}

		try {
			setSupportingDocUploading(true);

			// Get the case ID from the pending action
			const caseId = pendingAction.parameters.id;

			// Find the message to mark as completed
			const targetMessage = messages.find((msg) => msg.id === messageId);

			// Add the user's selection as a message
			const userMsg = {
				id: Date.now(),
				text: `Uploading document: ${supportingDocFile.name} (${supportingDocName})`,
				sender: 'client',
			};

			// Update messages to mark user input as provided and add user response
			const messageIndex = messages.findIndex(
				(msg) => msg.id === messageId,
			);
			const updatedMessages = [
				...messages.slice(0, messageIndex),
				{
					...targetMessage,
					user_input_provided: true,
				},
				userMsg,
				...messages.slice(messageIndex + 1),
			];
			setMessages(updatedMessages);

			// Process the upload - similar to handleSubmit in PrepareLetter.js
			// 1. Get the file extension
			const get_ext = supportingDocFile.name.split('.');
			const ext = get_ext[get_ext.length - 1];

			// 2. Get a signed URL from the backend
			const res = await axios.get(
				`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=case_supporting_documents&file_name=${caseId}${supportingDocFile.uid}&ext=${ext}&id=${caseId}`,
				{
					headers: {
						'Content-type': 'application/json; charset=UTF-8',
						Authorization: 'Bearer ' + getUserToken(),
					},
				},
			);

			// 3. Upload the file to S3
			const result = await axios.put(res.data.data, supportingDocFile);

			if (result.status === 200) {
				// 4. Create the document path
				const documentPath = `/case_supporting_documents/${caseId}/${caseId}${supportingDocFile.uid}.${ext}`;

				// 5. Create the document object
				const newFile = {
					uid: supportingDocFile.uid,
					name: supportingDocFile.name,
					status: 'done',
					url: documentPath,
				};

				// 6. Prepare the data for submission
				const submitData = {
					id: caseId,
					supporting_docs: [
						{
							url: newFile,
							document_name: supportingDocName,
						},
					],
					upload_documents: true,
				};

				// 7. Store the user input using the target message's MongoDB _id
				storeMessage({
					conversation_id: activeConversationId,
					user_input: `Uploaded document: ${supportingDocFile.name} (${supportingDocName})`,
					role: 'user',
					message_id: targetMessage._id,
				});

				// 8. Submit to the API via action
				onActionReceived('upload_supporting_document', submitData);

				// 9. Add a processing message
				const processingMsg = {
					id: Date.now() + 1,
					text: 'Uploading your document...',
					sender: 'system',
					isProcessing: true,
				};
				setMessages([...updatedMessages, processingMsg]);

				// 10. Reset states
				setSupportingDocFileList([]);
				setSupportingDocFile(null);
				setSupportingDocName('');
				setPendingUserInput(null);
				setPendingAction(null);
			}
		} catch (error) {
			// Handle error
			console.error('Error uploading document:', error);
			notification.error({
				message: 'Upload Failed',
				description: 'Could not upload the document. Please try again.',
			});

			// Add error message
			const errorMsg = {
				id: Date.now() + 1,
				text: 'Failed to upload the document. Please try again.',
				sender: 'system',
			};
			setMessages([...messages, errorMsg]);
		} finally {
			setSupportingDocUploading(false);
		}
	};

	useEffect(() => {
		// Add the class to the body tag
		document.body.classList.add('shieldMaxxBG');
		// Clean up to remove the class when the component unmounts
		return () => {
			document.body.classList.remove('shieldMaxxBG');
		};
	}, []);

	// Add useEffect to handle storeMessage API responses and update local messages with real MongoDB IDs
	useEffect(() => {
		if (storeMessageApiState === 'success' && storeMessageData) {
			// Find the message that was just stored and update it with the real MongoDB ID
			if (storeMessageData.message_id) {
				setMessages((prevMessages) =>
					prevMessages.map((msg) => {
						// Find messages that don't have a real _id yet (temporary messages)
						if (!msg._id || msg._id.startsWith('temp_')) {
							// Match by content and timestamp (since they were just created)
							const isMatchingMessage =
								msg.text === storeMessageData.response ||
								msg.user_input ===
									storeMessageData.user_input ||
								(msg.sender === 'system' &&
									msg.action === storeMessageData.action &&
									Math.abs(msg.id - Date.now()) < 5000); // Within 5 seconds

							if (isMatchingMessage) {
								return {
									...msg,
									_id: storeMessageData.message_id, // Update with real MongoDB ID
								};
							}
						}
						return msg;
					}),
				);
			}

			// Reset the store message state
			resetStoreMessage();
		}
	}, [storeMessageApiState, storeMessageData]);

	// Around line 180, add a useEffect to call the callback whenever messages change
	useEffect(() => {
		if (onMessagesChange) {
			onMessagesChange(messages);
		}
	}, [messages, onMessagesChange]);

	// Modify the useEffect for dashboard message
	useEffect(() => {
		// Check if we have a message and if it's different from what we've already processed
		if (
			location.state?.dashboardMessage &&
			location.state?.fromDashboard &&
			location.state.dashboardMessage !== processedMessageRef.current
		) {
			// Store the message we're processing to avoid reprocessing
			processedMessageRef.current = location.state.dashboardMessage;

			// Hide greeting immediately
			setShowGreeting(false);
			setChatStarted(true);

			// Set a small delay to ensure component is fully mounted
			setTimeout(() => {
				// Set the message in the input field
				setInputMessage(location.state.dashboardMessage);
				chatInputForm.setFieldsValue({
					chatMessage: location.state.dashboardMessage,
				});

				// Send the message
				handleSendMessage(location.state.dashboardMessage);

				// Clear the location state to prevent reprocessing
				navigate(location.pathname, { replace: true });
			}, 100);
		}
	}, [location.state]);

	// Add a ref to track processed messages
	const processedMessageRef = useRef(null);

	return (
		<>
			<>
				{/* History buttons visible on both greeting and chat screens */}
				{showGreeting ? (
					<XThemeContainer fluid>
						<XThemShieldDesktop className="pt-5">
							{/* {historyButtons} */}
							<Col xs={24} className="text-end">
								<Dropdown
									overlay={historyMenu}
									trigger={['click']}
									placement="bottomRight"
									size="large"
									onVisibleChange={
										handleHistoryDropdownVisibleChange
									}
								>
									<XTheme2Button
										className="chatStyle noBackground me-2"
										size="large"
										icon={<HistoryOutlined />}
									/>
								</Dropdown>
							</Col>
							<Row
								gutter={[15, 15]}
								className="align-items-center mt-4"
							>
								<Col
									xs={{ span: 6, offset: 9 }}
									sm={{ span: 4, offset: 10 }}
									md={{ span: 4, offset: 10 }}
									lg={{ span: 4, offset: 10 }}
									className="text-center mb-3"
								>
									<XLottieShieldMaxx
										animationData={ReclaimJson}
										loop={true}
									/>
								</Col>
								<Col xs={24} className="text-center">
									<XShieldMaxxTitle>
										Hi, I am Maxx
									</XShieldMaxxTitle>
								</Col>
								<Col
									xs={{ span: 24 }}
									sm={{ span: 24 }}
									md={{ span: 24 }}
									lg={{ span: 8, offset: 8 }}
									className="text-center"
								>
									<ParaShieldMaxx>
										Your Autonomous Assistant for Case
										Management
									</ParaShieldMaxx>
								</Col>
								<Col
									xs={{ span: 24 }}
									sm={{ span: 24 }}
									md={{ span: 16, offset: 4 }}
									className="text-center mt-3"
								>
									<Form
										name="chatForm"
										// layout="vertical"
										className="w-100 mb-0 pb-0"
										form={chatInputForm}
									>
										<Form.Item
											name="chatMessage"
											className="mb-0"
										>
											<XTextAreaShieldMaxx
												style={{
													boxShadow:
														'0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
												}}
												rows={1}
												autoSize={{
													minRows: 2,
													maxRows: 4,
												}}
												size="large"
												value={inputMessage}
												onChange={handleInputTyping}
												onPressEnter={(e) => {
													e.preventDefault();
													handleSendMessage();
												}}
												placeholder="Ask Maxx to show pending case or Ask to Analyse pending cases from EHR..."
												disabled={false}
											/>
										</Form.Item>
										<Form.Item className="mb-0">
											{isListening ? (
												<StyledWrapper>
													<div className="loader">
														<div className="logo">
															<img
																className="img-fluid"
																src="/images/mice-icon.svg"
																alt="Voice"
																width={20}
															/>
														</div>
														<div className="box" />
														<div className="box" />
														<div className="box" />
														<div className="box" />
													</div>
												</StyledWrapper>
											) : (
												<XTextAreaShieldMaxxBTN className="mainUpload mb-1">
													<div className="iconButtonRight">
														<XTheme2Button
															shape="square"
															size="large"
															icon={
																<ArrowUpOutlined />
															}
															onClick={() =>
																handleSendMessage()
															}
															loading={
																isListening
															}
															disabled={
																!inputMessage
															}
														/>
													</div>
												</XTextAreaShieldMaxxBTN>
											)}
										</Form.Item>
									</Form>
								</Col>
								<Col xs={24} className="text-center">
									<Space
										direction=""
										size={10}
										className="justify-content-center align-items-center flex-wrap"
									>
										<XThemeReclaimSuggestionBTN
											icon={
												<img
													src="/images/suggestion-icon.svg"
													alt=""
												/>
											}
											onClick={() =>
												handleSuggestionClick(
													'Pull Pending Cases from EHR',
												)
											}
										>
											Pull Pending Cases from EHR
											<UpCircleTwoTone
												twoToneColor="rgba(26, 29, 35, 0.1)"
												className="ms-1"
											/>
										</XThemeReclaimSuggestionBTN>

										<XThemeReclaimSuggestionBTN
											icon={
												<img
													src="/images/suggestion-icon.svg"
													alt=""
												/>
											}
											onClick={() =>
												handleSuggestionClick(
													'Show Pending Cases',
												)
											}
										>
											Show Pending Cases
											<UpCircleTwoTone
												twoToneColor="rgba(26, 29, 35, 0.1)"
												className="ms-1"
											/>
										</XThemeReclaimSuggestionBTN>

										<XThemeReclaimSuggestionBTN
											icon={
												<img
													src="/images/suggestion-icon.svg"
													alt=""
												/>
											}
											onClick={() =>
												handleSuggestionClick(
													'Can you pull few cases from EHR?',
												)
											}
										>
											Can you pull few cases from EHR?
											<UpCircleTwoTone
												twoToneColor="rgba(26, 29, 35, 0.1)"
												className="ms-1"
											/>
										</XThemeReclaimSuggestionBTN>
									</Space>
								</Col>
							</Row>
						</XThemShieldDesktop>
					</XThemeContainer>
				) : (
					<>
						{showGreeting ? (
							// Greeting screen
							<>
								<div className="header">{historyButtons}</div>
								<div className="leftScrollData">
									<Row className="my-4">
										<Col
											xs={{ span: 12, offset: 6 }}
											sm={{ span: 6, offset: 9 }}
											className="text-center mb-4"
										>
											{/* <img
										src="/images/va-animation.svg"
										alt=""
									/> */}
											<XLottieLetter
												animationData={AppealLoading}
												loop={true}
											/>
										</Col>
										<Col xs={24} className="text-center">
											<div className="asistCardTitle">
												{greeting}, {userInfo.name}!{' '}
												<br />
												How can I assist you today?
											</div>
										</Col>
									</Row>
									<div className="cardSuggestions">
										<h3 className="mb-2">
											Suggested Actions
										</h3>
										<p
											onClick={() =>
												handleSuggestionClick(
													'Show me my pending cases',
												)
											}
											role="button"
										>
											Show me my pending cases
										</p>
										<p
											onClick={() =>
												handleSuggestionClick(
													'Analyze case 682716759804a6703acbb1ff',
												)
											}
											role="button"
										>
											Analyze case "Xyz"
										</p>
										<p
											onClick={() =>
												handleSuggestionClick(
													'Upload supporting docs for case 682716759804a6703acbb1ff',
												)
											}
											role="button"
										>
											Upload supporting docs for case
											"Xyz"
										</p>
									</div>
								</div>
							</>
						) : (
							// Chat interface
							<>
								{/* <div className="headerBar">
							<Row align="middle">
								<Col xs={14}>
									<XThemeHeaderBTN size="large">
										<span
											style={{
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap',
												display: 'block',
												maxWidth: '150px',
											}}
										>
											{chatTitle}
										</span>
									</XThemeHeaderBTN>
								</Col>
								<Col xs={10}></Col>
							</Row>
						</div> */}
								<div className="header">{historyButtons}</div>
								<div
									className="leftScrollData"
									ref={scrollWrapperRef}
								>
									{messages.map((msg) => (
										<>
											<div
												key={msg.id}
												className={
													msg.sender === 'system'
														? 'textChat'
														: 'textChat textChat_reply'
												}
											>
												<div className="textChatContainer">
													<div className="textChatImage">
														<XAvatar
															size={25}
															src={
																msg.sender ===
																'system'
																	? '/images/reclaim_chat_icon.svg'
																	: userInfo.profile ===
																	  'undefined'
																	? '/images/chat-user.svg'
																	: `${userInfo.profile}`
															}
														/>
													</div>

													{msg.isThinking ? (
														<ThinkingText className="textChatText">
															{msg.text}
														</ThinkingText>
													) : (
														<div className="textChatText">
															{typingMessageId ===
															msg.id ? (
																typingText
															) : (
																<>
																	{/<[a-z][\s\S]*>/i.test(
																		msg.text,
																	) ? (
																		<div
																			dangerouslySetInnerHTML={{
																				__html: msg.text,
																			}}
																		/>
																	) : (
																		msg.text
																	)}
																</>
															)}
															{msg.isProcessing && (
																<span className="processingIndicator">
																	<span className="dot"></span>
																	<span className="dot"></span>
																	<span className="dot"></span>
																</span>
															)}

															{/* Render user input inline if message has user_input and it's not provided */}
															{msg.user_input &&
																!msg.user_input_provided && (
																	<div
																		className="userInputWrapper"
																		style={{
																			marginTop:
																				'10px',
																		}}
																	>
																		{renderUserInputUI(
																			msg.user_input,
																			msg.id,
																		)}
																	</div>
																)}
														</div>
													)}
												</div>
											</div>
										</>
									))}

									{isTyping && (
										<TypingLoaderWrapper>
											<div className="typing-indicator">
												<div className="typing-circle" />
												<div className="typing-circle" />
												<div className="typing-circle" />
												<div className="typing-shadow" />
												<div className="typing-shadow" />
												<div className="typing-shadow" />
												<div className="typing-shadow" />
											</div>
										</TypingLoaderWrapper>
									)}

									{/* {pendingUserInput && (
										<div className="textChat">
											<div className="textChatContainer">
												<div className="textChatImage">
													<XAvatar
														size={25}
														src="/images/chat-reply.svg"
													/>
												</div>
												<div className="textChatText userInputWrapper">
													{renderUserInputUI(
														pendingUserInput,
													)}
												</div>
											</div>
										</div>
									)} */}
								</div>
							</>
						)}
						<div className="footer">
							<>
								<Form
									name="chatForm"
									// layout="vertical"
									className="w-100 mb-0 pb-0"
									form={chatInputForm}
								>
									<Form.Item
										name="chatMessage"
										className="mb-0"
									>
										<XTextAreaShieldMaxx2
											className="smallChatBox"
											rows={2}
											autoSize={{
												minRows: 2,
												maxRows: 4,
											}}
											name="chatMessage"
											size="large"
											placeholder={
												// messages.some(
												// 	(msg) =>
												// 		msg.user_input &&
												// 		!msg.user_input_provided,
												// )
												// 	? 'Please make a selection above to continue'
												// 	:
												'Ask Maxx to show pending case or Ask to Analyse pending cases from EHR'
											}
											value={inputMessage}
											onChange={handleInputTyping}
											onPressEnter={(e) => {
												e.preventDefault();
												handleSendMessage();
											}}
											// disabled={messages.some(
											// 	(msg) =>
											// 		msg.user_input &&
											// 		!msg.user_input_provided,
											// )}
										/>
									</Form.Item>

									<Form.Item className="mb-0">
										{isListening ? (
											<StyledWrapper>
												<div className="loader">
													<div className="logo">
														<img
															className="img-fluid"
															src="/images/mice-icon.svg"
															alt="Voice"
															width={20}
														/>
													</div>
													<div className="box" />
													<div className="box" />
													<div className="box" />
													<div className="box" />
												</div>
											</StyledWrapper>
										) : (
											<XTextAreaShieldMaxxBTN2 className="innerUpload smallChatBox">
												{/* <div className="iconButtonLeft">
											<Upload
											// {...uploadProps}
											// onRemove={
											// 	handleRemoveFile
											// }
											>
												<LinkOutlined className="me-1" />{' '}
												Upload File
											</Upload>
										</div> */}
												<div className="iconButtonRight">
													<XTheme2Button
														className="chatStyle"
														icon={
															<ArrowUpOutlined />
														}
														type="primary"
														htmlType="submit"
														onClick={() =>
															handleSendMessage()
														}
														loading={isListening}
														// disabled={messages.some(
														// 	(msg) =>
														// 		msg.user_input &&
														// 		!msg.user_input_provided,
														// )}
														// icon={
														// 	inputMessage.trim() ? (
														// 		<SendOutlined />
														// 	) : (
														// 		<img
														// 			className="img-fluid"
														// 			src="/images/mice-icon.svg"
														// 			alt="Voice"
														// 			width={20}
														// 			onClick={
														// 				startVoiceRecognition
														// 			}
														// 		/>
														// 	)
														// }
													/>
												</div>
											</XTextAreaShieldMaxxBTN2>
										)}
									</Form.Item>
								</Form>
							</>
						</div>
					</>
				)}
			</>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		// Send Message
		sendMessageApiState: state.sendMessage.apiState,
		sendMessageData: state.sendMessage.data,
		sendMessageError: state.sendMessage.error,

		// Store Message
		storeMessageApiState: state.storeMessage.apiState,
		storeMessageData: state.storeMessage.data,
		storeMessageError: state.storeMessage.error,

		// Send Message Stream
		sendMessageStreamApiState: state.sendMessageStream.apiState,
		sendMessageStreamData: state.sendMessageStream.data,
		sendMessageStreamError: state.sendMessageStream.error,
		sendMessageStreamState: state.sendMessageStream.streamingState,
		sendMessageStreamAccumulatedText:
			state.sendMessageStream.accumulatedText,
		sendMessageStreamThinkingText: state.sendMessageStream.thinkingText,
		sendMessageStreamConversationId: state.sendMessageStream.conversationId,

		// Get Conversation History
		getConversationHistoryApiState: state.getConversationHistory.apiState,
		getConversationHistoryData: state.getConversationHistory.data,
		getConversationHistoryError: state.getConversationHistory.error,
		// Get User Conversations
		getUserConversationsApiState: state.getUserConversations.apiState,
		getUserConversationsData: state.getUserConversations.data,
		getUserConversationsError: state.getUserConversations.error,
		// Delete Conversation
		deleteConversationApiState: state.deleteConversation.apiState,
		deleteConversationData: state.deleteConversation.data,
		deleteConversationError: state.deleteConversation.error,
		// Update Conversation Title
		updateConversationTitleApiState: state.updateConversationTitle.apiState,
		updateConversationTitleData: state.updateConversationTitle.data,
		updateConversationTitleError: state.updateConversationTitle.error,
		// New state mappings for entity searches
		getStateDropdownState: state.getStateDropdown,
		getHospitalDropdownState: state.getHospitalDropdown,
		getInsuranceDropdownState: state.getInsuranceDropdown,
		getRegionsState: state.getRegions,
		getOrganizationsState: state.getOrganizations,

	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// Send Message
		sendMessage: (data) => dispatch(sendMessageApi(data)),
		resetSendMessage: () => dispatch(sendMessageReset()),

		// Store Message
		storeMessage: (data) => dispatch(storeMessageApi(data)),
		resetStoreMessage: () => dispatch(storeMessageReset()),

		// Send Message Stream
		sendMessageStream: (data) => dispatch(sendMessageStreamApi(data)),
		resetSendMessageStream: () => dispatch(sendMessageStreamReset()),

		// Get Conversation History
		getConversationHistory: (data) =>
			dispatch(getConversationHistoryApi(data)),
		resetGetConversationHistory: () =>
			dispatch(getConversationHistoryReset()),
		// Get User Conversations
		getUserConversations: (data) => dispatch(getUserConversationsApi(data)),
		resetGetUserConversations: () => dispatch(getUserConversationsReset()),
		// Delete Conversation
		deleteConversation: (data) => dispatch(deleteConversationApi(data)),
		resetDeleteConversation: () => dispatch(deleteConversationReset()),
		// Update Conversation Title
		updateConversationTitle: (data) =>
			dispatch(updateConversationTitleApi(data)),
		resetUpdateConversationTitle: () =>
			dispatch(updateConversationTitleReset()),
		// New dispatch mappings for entity searches
		getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
		getStateDropdownReset: () => dispatch(getStateDropdownReset()),
		getHospitalDropdown: (params) =>
			dispatch(getHospitalDropdownApi(params)),
		getHospitalDropdownReset: () => dispatch(getHospitalDropdownReset()),
		getInsuranceDropdown: (params) =>
			dispatch(getInsuranceDropdownApi(params)),
		getRegions: (params) => dispatch(getRegionsApi(params)),
		getOrganizations: (data) => dispatch(getOrganizationsApi(data)),

	};
};

export default connect(mapStateToProps, mapDispatchToProps)(UnifiedChat);
